import {
  LodgeCard,
  AttractionCard,
  SightingCard,
  SidetripCard,
  FlightCard,
} from '../components/Cards';

export const entityComponents = {
  lodges: LodgeCard,
  lodgings: LodgeCard,
  attractions: AttractionCard,
  sightings: SightingCard,
  sidetrips: SidetripCard,
  flights: FlightCard,
};



// WEBPACK FOOTER //
// ./src/constants/entityComponents.js